<template>
	<div
		ref="tooltipHandler"
		v-tooltip="{ content: labelIsOverflown ? label : '', classes: tooltipClass }"
		v-observe-visibility="detectTooltipVisibility"
		:class="[wrapperClass, labelIsOverflown ? 'has-tooltip' : '', highlighted ? '-highlighted' : '']"
		@mouseover="detectTooltipVisibility"
	>
		<slot :label="label" />
	</div>
</template>

<script>
import { isOverflown } from '../util/helpers';
import { VTooltip } from 'v-tooltip';

const INPUT_MAX_LENGTH = 50;

export default {
	name:       'LabelWithTooltip',
	directives: {
		tooltip: VTooltip,
	},
	props: {
		label: {
			type:     String,
			required: true,
		},
		refElement: {
			type: String,
		},
		overflowLength: {
			type:    Number,
			default: INPUT_MAX_LENGTH / 2,
		},
		wrapperClass: {
			type:    String,
			default: 'label-with-tooltip text-with-ellipsis',
		},
		tooltipClass: {
			type:    String,
			default: '',
		},
		highlighted: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			labelIsOverflown: false,
		};
	},
	mounted() {
		this.detectTooltipVisibility();
	},
	methods: {
		detectTooltipVisibility() {
			if (this.refElement) {
				const scopedSlot = this.$scopedSlots.default()[0];
				if (scopedSlot) {
					const $refs = scopedSlot.context.$refs;
					if ($refs[this.refElement]) {
						this.labelIsOverflown = isOverflown($refs[this.refElement]);
					}
				}
			} else {
				this.labelIsOverflown = this.label.length >= this.overflowLength;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.text-with-ellipsis {
	min-width: 100%;
	> * {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}

.-highlighted {
	color: var(--color-hype-yellow);
}
</style>
